import React, { Suspense } from 'react';
import { Spinner } from "react-bootstrap";

import Belt from '../components/Belt';
import BeltLogged from '../components/BeltLogged';
import Footer from '../components/Footer';

const EditSparingPartner = React.lazy(() => import('../forms/EditSparingPartnerFormNew.js'));

class ProfileSparingEditPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
        document.title = "Edytuj ogłoszenie sparingpartner - RezerwujKort.pl";
    }

    render() {

        const editSparingPartner = (
            <div>
                <Suspense fallback={
                    <div>
                        <Spinner
                            style={{ borderStyle: 'dotted', marginLeft: '50%' }}
                            animation="border"
                        />
                    </div>
                }>
                    <EditSparingPartner slug={this.props.match.params.slug} />
                </Suspense>
            </div>
        );

        return (
            <div>
                <Belt />
                <BeltLogged />
                {editSparingPartner}
                <Footer />
            </div>
        );
    }
}

export default ProfileSparingEditPage;